import { Divider, Typography } from 'antd';

import type { ImpactReportView } from 'v2/interfaces/impactMeter';

import { Icon } from '@eduzz/ui-antd-theme';

import { formatIntegerImpact, formatJourney, formatLast30Days } from './formatImpact';

const ICON_CLASS = 'shrink-0 text-(--uizz-antd-color-white) lg:hidden';
const IMPACT_METRIC_SURFACE = 'bg-[#00264D]/40';

type ImpactMetricsProps = {
  report: ImpactReportView;
};

function ImpactMetrics({ report }: ImpactMetricsProps) {
  const metrics = [
    {
      key: 'unique',
      value: formatIntegerImpact(report.impactedLivesCount),
      label: 'pessoas únicas impactadas',
      icon: <Icon.Users size={18} className={ICON_CLASS} aria-hidden />
    },
    {
      key: 'products',
      value: formatIntegerImpact(report.impactfulProductsCount),
      label: 'produtos com impacto',
      icon: <Icon.Box size={18} className={ICON_CLASS} aria-hidden />
    },
    {
      key: 'last30',
      value: formatLast30Days(report.impactedLivesLast30Days),
      label: 'novas pessoas em 30 dias',
      icon: <Icon.TrendingUp size={18} className={ICON_CLASS} aria-hidden />
    },
    {
      key: 'journey',
      value: formatJourney(report),
      label: 'de jornada na Eduzz',
      icon: <Icon.CalendarClock size={18} className={ICON_CLASS} aria-hidden />
    }
  ];

  return (
    <div className='grid w-full grid-cols-2 gap-2 lg:flex lg:flex-row lg:flex-wrap lg:items-baseline lg:justify-between lg:gap-x-4 lg:gap-y-2'>
      {metrics.map((metric, index) => (
        <div key={metric.key} className='contents'>
          {index > 0 ? <Divider type='vertical' className='mx-0 hidden h-6 border-white/20 lg:block' /> : null}
          <div
            id={`impact-meter-metric-${metric.key}`}
            className={`flex flex-col gap-0.5 rounded-(--uizz-antd-border-radius) px-3 py-2 lg:flex-row lg:items-baseline lg:gap-x-1.5 lg:rounded-none lg:bg-transparent lg:p-0 ${IMPACT_METRIC_SURFACE}`}
          >
            <div className='flex items-center gap-1.5 lg:contents'>
              {metric.icon}
              <Typography.Text className='text-xl leading-6 font-bold whitespace-nowrap text-(--uizz-antd-color-white) lg:text-[19px] lg:font-semibold'>
                {metric.value}
              </Typography.Text>
            </div>
            <Typography.Text className='text-xs leading-4 text-balance text-(--uizz-antd-color-white) lg:text-sm lg:leading-5 lg:whitespace-nowrap'>
              {metric.label}
            </Typography.Text>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ImpactMetrics;
